export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  cptGroupClinicId: number;
  createdById: number;
  createdByDate: string;
  cptGroupId: number;
  cptGroupStatus: number;
  cptGroupName: string;
  cptGroupCode: string;
};

export type MasterDataType = {
  cptGroupId: number;
  cptGroupCode: string;
  cptGroupName: string;
  cptGroupStatus: number;
  cptGroupCreatedById: number;
  cptGroupClinicId: number;
  cptGroupCreatedByDate: string;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  cptGroupCode: string;
  cptGroupName: string;
  cptGroupStatus: number;
};

export const initialFormData: MasterFormDataType = {
  cptGroupCode: "",
  cptGroupName: "",
  cptGroupStatus: 1,
};
